import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/buttons/arrow-diag.svg'
import _imports_1 from '@assets/img/Rolling-loading.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2da4fa0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "payment_SEPA",
  class: "payment_account_number tab-pane"
}
const _hoisted_2 = {
  action: "",
  class: "form_paym_account_number form_box",
  role: "form",
  "data-lng": "ru"
}
const _hoisted_3 = { class: "recipient-detale" }
const _hoisted_4 = { class: "field form-group" }
const _hoisted_5 = { for: "ac_num_addressee" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "field form-group" }
const _hoisted_8 = { for: "ac_address" }
const _hoisted_9 = {
  class: "field form-group",
  style: { 'margin-bottom': '40px' }
}
const _hoisted_10 = { for: "country_field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-block with-errors" }, null, -1))
const _hoisted_12 = { class: "field form-group" }
const _hoisted_13 = { for: "country_field" }
const _hoisted_14 = { class: "field form-group" }
const _hoisted_15 = { for: "country_field" }
const _hoisted_16 = { class: "field form-group" }
const _hoisted_17 = { for: "country_field" }
const _hoisted_18 = {
  class: "field form-group",
  style: { 'margin-bottom': '40px' }
}
const _hoisted_19 = { for: "country_field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-block with-errors" }, null, -1))
const _hoisted_21 = { class: "field form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "ac_iban" }, "IBAN", -1))
const _hoisted_23 = { class: "field form-group" }
const _hoisted_24 = { for: "ac_sum" }
const _hoisted_25 = { class: "field form-group" }
const _hoisted_26 = { for: "ac_payment_purpose" }
const _hoisted_27 = { class: "additional_field" }
const _hoisted_28 = { for: "sample_save" }
const _hoisted_29 = {
  key: 1,
  class: "field form-group",
  style: { marginTop: '15px' }
}
const _hoisted_30 = { for: "ac_sample_name" }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "additional_field" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = {
  key: 3,
  class: "error"
}
const _hoisted_35 = { class: "btn_box" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "loader"
}, null, -1))
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_select_country = _resolveComponent("select-country")!
  const _component_ui_select = _resolveComponent("ui-select")!
  const _component_ui_toggler = _resolveComponent("ui-toggler")!
  const _component_aba_button = _resolveComponent("aba-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$localization.getTranslate("Receipient Detale")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$localization.getTranslate("Beneficiary")), 1),
        _createVNode(_component_ui_input, {
          modelValue: _ctx.Recipient,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Recipient) = $event)),
          placeholder: _ctx.$localization.getTranslate('name'),
          iconName: "person-icon",
          required: ""
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      (!_ctx.isOffline)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$localization.getTranslate("Address")), 1),
              _createVNode(_component_ui_input, {
                modelValue: _ctx.BeneficiaryAddress,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.BeneficiaryAddress) = $event)),
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$localization.getTranslate("Country")), 1),
              _createVNode(_component_select_country, {
                onOnChange: _ctx.selectBeneficiaryCountryCode,
                valueCode: _ctx.BeneficiaryCountryCode
              }, null, 8, ["onOnChange", "valueCode"]),
              _hoisted_11
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$localization.getTranslate("City")), 1),
              _createVNode(_component_ui_input, {
                modelValue: _ctx.BeneficiaryCity,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.BeneficiaryCity) = $event)),
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$localization.getTranslate("State")), 1),
              _createVNode(_component_ui_input, {
                modelValue: _ctx.BeneficiaryState,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.BeneficiaryState) = $event)),
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$localization.getTranslate("PostalCode")), 1),
              _createVNode(_component_ui_input, {
                modelValue: _ctx.BeneficiaryPostalCode,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.BeneficiaryPostalCode) = $event)),
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$localization.getTranslate("BeneficiaryType")), 1),
              _createVNode(_component_ui_select, {
                style: { width: `100%`, 'max-width': '400px' },
                items: _ctx.itemsBeneficiaryType,
                modelValue: _ctx.BeneficiaryType,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.BeneficiaryType) = $event))
              }, null, 8, ["items", "modelValue"]),
              _hoisted_20
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode(_component_ui_input, {
          modelValue: _ctx.IBAN,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.IBAN) = $event)),
          iconName: "world-sphere-icon",
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$localization.getTranslate("Amount")), 1),
        _createVNode(_component_ui_input, {
          modelValue: _ctx.Amount,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.Amount) = $event)),
          type: "number",
          currency: "EUR",
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$localization.getTranslate("PurposePayment")), 1),
        _createVNode(_component_ui_input, {
          modelValue: _ctx.PurposePayment,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.PurposePayment) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_ui_toggler, {
          modelValue: _ctx.IsSave,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.IsSave) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$localization.getTranslate("SavePaymentAsSample")), 1)
      ]),
      (_ctx.IsSave)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$localization.getTranslate("SampleName")), 1),
            _createVNode(_component_ui_input, {
              modelValue: _ctx.Name,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.Name) = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.IsSave)
        ? (_openBlock(), _createElementBlock("br", _hoisted_31))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_ui_toggler, {
          modelValue: _ctx.IsConfirmCondition,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.IsConfirmCondition) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", {
          for: "conditions-checkbox",
          innerHTML: _ctx.$localization.getTranslate('ConfirmConditionText')
        }, null, 8, _hoisted_33)
      ]),
      (_ctx.ErrorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.ErrorMessage), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_35, [
        (!_ctx.IsLoad)
          ? (_openBlock(), _createBlock(_component_aba_button, {
              key: 0,
              class: "active m-2",
              btnSize: "btnLarge",
              onClick: _ctx.getCommission
            }, {
              default: _withCtx(() => [
                _hoisted_36,
                _createTextVNode("  "),
                _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Send money")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass([{ active: _ctx.IsLoad }, "loader-gif inline"])
        }, _hoisted_38, 2)
      ])
    ])
  ]))
}